import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_ASSETS_CLIENTS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_client_asset = (data) => {
    return (dispatch, getState) => {


        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/bp/client/bundle-load/${data.clientId}`, config)
                .then(response => {
                    dispatch({
                        type: BP_ASSETS_CLIENTS_GET,
                        payload: {
                            clientBundle: response.data,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    dispatch({
                        type: BP_ASSETS_CLIENTS_GET,
                        payload: {
                            clientBundle: {
                                errors: {},
                            },
                            task: {
                                result: false
                            }
                        }
                    })
                });

        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_client_asset;
